<template>
  <div
    class="medicaseItem"
    @click.stop="toDetail"
    :class="{
      backgroundNone: showContext,
      'pb-32': showContext,
      'pb-24': !showContext
    }"
  >
    <h4
      class="medicaseName text-overflow"
      :class="item.finished ? 'medicaseName-right' : 'medicaseName-noRight'"
      v-if="!showContext"
    >
      {{ item.medicaseName }}
    </h4>
    <!-- 显示材料 -->
    <div class="showContextWrapper flexBox" v-if="showContext">
      <div class="imgBox">
        <img v-lazy="item.cover" :alt="item.medicaseName" />
      </div>
      <div class="info">
        <h4 class="name text-overflow" v-if="showContext">
          {{ item.medicaseName }}
        </h4>
        <p class="author text-overflow" v-if="item.experts.length">
          <span
            class="expert"
            v-for="(info, key) in item.experts"
            :key="info.expertId ? info.expertId : info.expert_id"
            >{{
              (key > 0 ? '、' : '') +
              (info.expertName ? info.expertName : info.expert_name)
            }}</span
          >
          <span style="font-weight: normal"
            >&nbsp;{{
              item.experts[0]['hospitalName']
                ? item.experts[0]['hospitalName']
                : item.experts[0]['hospital_name']
            }}</span
          >
        </p>
        <div class="msg text-overflow">
          <span v-if="item.questionCount">{{ item.questionCount }}题</span>
          <span v-if="item.userCount && item.questionCount"> | </span>
          <span v-if="item.userCount">{{ item.userCount }}位医生参与</span>
        </div>
      </div>
    </div>
    <!-- 不显示材料 -->
    <div class="infoWrapper flexBox" v-else>
      <div class="imgBox">
        <img v-lazy="item.cover" :alt="item.medicaseName" />
      </div>
      <div class="info">
        <p class="author" v-if="item.experts?.length">
          <span
            class="expert"
            v-for="(info, key) in item.experts"
            :key="info.expertId ? info.expertId : info.expert_id"
            >&nbsp;{{
              (key > 0 ? '、' : '') +
              (info.expertName ? info.expertName : info.expert_name)
            }}
            <!--  {{info.expert_name}} -->
          </span>
          <span
            >&nbsp;{{
              item.experts[0]['hospitalName']
                ? item.experts[0]['hospitalName']
                : item.experts[0]['hospital_name']
            }}</span
          >
        </p>
        <div class="msg text-overflow">
          <span v-if="item.questionCount">{{ item.questionCount }}题</span>
          <span v-if="item.userCount && item.questionCount"> | </span>
          <span v-if="item.userCount">{{ item.userCount }}位医生参与</span>
        </div>
        <div class="finished" v-if="item.finished"></div>
      </div>
    </div>
    <div class="context" v-if="item.contextDetail && showContext">
      <template v-for="(d, ind) in item.contextDetail" :key="ind">
        <span v-if="d.type === 'TEXT'"
          ><span clss="themeColor material">(材料)</span>
          <template v-for="t in d.values">
            {{ t }}
          </template>
        </span>
        <div v-else-if="d.type === 'HTML'" class="htmlBox">
          <template v-for="(h, i) in d.values" :key="i">
            <span clss="themeColor material">(材料)</span>
            <div v-if="/^<p><img/.test(h)">[图片][图片]</div>
            <div
              v-else
              v-html="h.replace(/(style=)/g, 's=').replace(/(src=)/g, 's=')"
            ></div>
          </template>
        </div>
      </template>
    </div>
    <div class="description" v-if="item.description && !showContext">
      <p>{{ item.description }}</p>
    </div>
    <div
      class="btn"
      :class="{ mask1: ind == 0, mask2: ind == 1 }"
      v-if="item.contextDetail && showContext"
    >
      <span>开始练习</span>
    </div>
    <slot name="line"></slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { userLogin, isLogin, appPort, jumpModuleApp } from '@/widget/index'
import { hostPath } from '@/public/utils/basePath'

export default defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showContext: {
      default: false,
      type: Boolean
    },
    ind: {
      type: Number,
      default: 0
    },
    depId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    toDetail() {
      if (!isLogin) {
        userLogin()
        return
      }
      this.$emit('toRecommend', { recommendType: 'AIexercise' })
      if (this.item.accessible == true || this.item.accessible == undefined) {
        // 已购买 或没有 accessible 参数 进入详情页
        var obj = {
          name: 'detailExercise',
          params: {
            id: this.item.paperId
          },
          query: {
            taskId: 0,
            ...this.$route.query
          }
        }
        this.$router.push(obj)
      } else {
        var query = this.$route.query
        if (this.depId && appPort()) {
          query.depId = this.depId
          let str = `${hostPath}/learn/guide/exam?depId=${this.depId}`
          jumpModuleApp({
            typeId: 'h5',
            url: str
          })
        } else {
          // 未购买进入导览页
          if (this.$route.name === 'successVip') {
            this.$router.replace({
              name: 'guideExam',
              query: query
            })
          } else {
            this.$router.push({
              name: 'guideExam',
              query: query
            })
          }
        }
      }
    }
  }
})
</script>
<style lang="scss">
.medicaseItem {
  .htmlBox {
    > span {
      color: #ff6600;
      margin-right: 16px;
    }
    b,
    strong {
      font-weight: normal;
    }
    > div {
      display: inline;
      p:first-child {
        display: inline;
        strong {
          font-weight: 500;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.pb-32 {
  padding-bottom: 32px;
}
.pb-24 {
  padding-bottom: 24px;
}
.medicaseItem {
  width: 686px;
  min-height: 200px;
  background: #ffffff;
  border-radius: 12px;
  box-sizing: border-box;
  padding-top: 38px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: top;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  .medicaseName {
    width: 512px;
    height: 44px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    margin-top: -8px;
    margin-bottom: 0.16rem;
  }
  .medicaseName-right {
    margin-right: 1rem;
  }
  .medicaseName-noRight {
    width: 100%;
    margin-right: 0;
  }
  .infoWrapper,
  .showContextWrapper {
    width: 646px;
    justify-content: space-between;
  }
  .imgBox {
    width: 136px;
    height: 136px;
    border-radius: 12px;
    background-color: #b1b1b3;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .info {
    width: 486px;
    font-family: PingFangSC-Medium, PingFang SC;
    .name {
      height: 44px;
      line-height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      margin-bottom: 4px;
    }
    .expert {
      font-weight: bold;
    }
    .author,
    .msg {
      font-size: 28px;
      font-weight: 500;
    }
    .author {
      line-height: 40px;
    }
    .msg {
      color: #969799;
    }
  }
  .infoWrapper {
    .author {
      text-indent: 60px;
      background: url('../../assets/icon/icon_from.png') no-repeat;
      background-position: 0 4px;
      background-size: 60px auto;
      min-height: 40px;
      @include multi-ellipsis(2);
      margin-bottom: 12px;
    }
    .msg {
      height: 40px;
      line-height: 40px;
    }
  }
  .showContextWrapper {
    .author {
      height: 40px;
      margin-bottom: 16px;
    }
    .msg {
      line-height: 32px;
    }
  }
  .description {
    min-height: 46px;
    line-height: 46px;
    margin-top: 24px;
    font-size: 28px;
    color: #626366;
    width: 646px;
    background: #f5f5f7;
    border-radius: 8px;
    padding: 16px 20px;
    p {
      @include multi-ellipsis(2);
    }
  }
  .finished {
    width: 104px;
    height: 104px;
    background: url('../../assets/icon/icon_finished.png') no-repeat center;
    background-size: 104px 104px;
    position: absolute;
    right: 8px;
    top: 0;
  }
  .context {
    width: 100%;
    min-height: 50px;
    font-size: 32px;
    line-height: 56px;
    overflow: hidden;
    position: relative;
    margin-top: 24px;
    padding-bottom: 8px;
    @include multi-ellipsis(2);
  }
  .mask1 {
    background: url('../../assets/img/exercise/btn_mark1.png') no-repeat 100%;
  }
  .mask2 {
    background: url('../../assets/img/exercise/btn_mark2.png') no-repeat 100%;
  }
  .mask1,
  .mask2 {
    background-position: 0 -10px;
  }
  .btn {
    position: absolute;
    bottom: 32px;
    left: 0;
    right: 0;
    text-align: center;
    padding-top: 10px;
    span {
      display: inline-block;
      width: 192px;
      height: 56px;
      font-size: 28px;
      line-height: 60px;
      background: #ff6600;
      border-radius: 44px;
      color: #fff;
      text-align: center;
    }
  }
}
.backgroundNone {
  background: none;
}
</style>
